import { Avatar, Breadcrumb, Button, Col, Divider, Drawer, Flex, Form, Input, Layout, Popconfirm, Row, Select, Table, Tag, theme, Grid } from 'antd';
import { FilterOutlined, HomeOutlined, DeleteOutlined, EyeOutlined, LeftOutlined, SettingOutlined, RightOutlined, MobileOutlined } from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react';
import sampleData from './sampleData';
import { COLOR } from '../../theme/constant';
import TimeSetting from './Time/Time';
import MeetingIntegration from './MeetingIntegration/MeetingIntegration';
import UserProfile from './UserProfile/UserProfile';
import CompanySetting from './CompanySetting/CompanySetting';
import DrawSignature from './SignatureSettings/DrawSignature';
import UploadSignature from './SignatureSettings/UploadSignature';
import SignatureSettings from './SignatureSettings/SignatureSettings';
import { useSelector } from 'react-redux';
import SettingsAPI from '../../../src/restAPI/SettingsAPI';
import ChangePassword from './ChangePassword';
import UserProfileAPI from '../../restAPI/UserProfileAPI';
import TwoFactorAuth from './2FA';
import Empty_profile_pic from '../../assets/image/empty_profile_pic.png';
import { useNavigate } from 'react-router-dom';

const { Search } = Input;
const { Header, Footer, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

export default function Settings({ props }) {
    const { companyId, token, userCompany, role } = useSelector(state => state.auth);
    const navigate = useNavigate();
    const url = 'https://i.pravatar.cc/600';
    const componentMounted = useRef(false);
    const screens = useBreakpoint();
    const [searchValues, setSearchValues] = useState({
        roleId: { filterBy: '', value: '' },
        roleName: { filterBy: '', value: '' },
        description: { filterBy: '', value: '' },
        status: { filterBy: '', value: '' },
    });
    const [filterValues, setFilterValues] = useState({});
    const [selectedItem, setSelectedItem] = useState(null);
    const [currentCompanyInfo, setCurrentCompanyInfo] = useState({});
    const [name, setName] = useState('');
    const [roleName, setRoleName] = useState('');
    const [imageUrl, setImageUrl] = useState();
    const [userProfileChanged, setUserProfileChanged] = useState(false);
    const protectedSettingNames = ['Company Settings', 'Meeting Integration Settings'];

    const hasAdminSettingsAccess = Array.isArray(role) && role.some((singleRole) =>
        singleRole?.roleName === 'Company Admin' || singleRole?.roleName === 'Admin'
    );

    const getCompanyInfo = () => {
        return userCompany.companyData.find(company => company.companyId == companyId)
    }

    const getProfileData = async (companyInfo) => {
        try {
            const res = await UserProfileAPI.getUserProfileByUserDetailsId(companyInfo.userDetailsId, companyId, token)
            return res?.data?.name || null;
        } catch (error) {
            console.log('error in fetching profile data :', error)
        }
    }

    useEffect(() => {
        if (companyId) {
            const companyInfo = getCompanyInfo()
            setCurrentCompanyInfo(companyInfo);
            setRoleName(companyInfo?.roles.length > 0 ? companyInfo.roles[0].roleName : "User");
            getImageUrl(companyInfo);
        }
    }, [companyId]);

    useEffect(() => {
        const fetchData = async (companyInfo) => {
            try {
                const name = companyInfo ? await getProfileData(companyInfo) : null
                setName(name);
                getImageUrl(companyInfo);
            } catch (error) {
                console.log('error in fetching profile data :', error)
            }
        }
        if (companyId) {
            const companyInfo = getCompanyInfo();
            fetchData(companyInfo)
        }
    }, [userProfileChanged, companyId])

    useEffect(() => {
        const isProtectedTabOpen = protectedSettingNames.includes(selectedItem?.name);
        if (isProtectedTabOpen && !hasAdminSettingsAccess) {
            setSelectedItem(null);
            navigate('/unauthorized', { replace: true });
        }
    }, [selectedItem, hasAdminSettingsAccess, navigate]);

    const getImageUrl = async (companyInfo) => {
        await SettingsAPI.geteProfileImageByUserDetailsId(companyInfo.userDetailsId, companyId, token).then((res) => {
            if (res?.data) {
                setImageUrl(res.data.profilePicture);
                if (userProfileChanged) {
                    setUserProfileChanged(false)
                }
            }
        }).catch(err => {
            console.log("error getting esignature data :", err.message);
        })
    }

    const { token: { colorBgContainer, borderRadiusLG, colorPrimaryBg, colorText }, } = theme.useToken();

    const groupedData = sampleData.reduce((acc, item) => {
        if (role.length > 0) {
            for (let value of role) {
                if (value.restricted) {
                    if (value.roleName === "Company Admin" || value.roleName === "Admin") {
                        acc[item.section] = acc[item.section] || [];
                        acc[item.section].push(item);
                        break; // Exit loop after condition is met
                    } else {
                        if (item.section && item.section !== "A") {
                            acc[item.section] = acc[item.section] || [];
                            acc[item.section].push(item);
                            break; // Exit loop after condition is met
                        }
                    }
                } else if (value?.permissions) {
                    for (let data of value.permissions) {
                        if (data.permissionName === "Settings") {
                            acc[item.section] = acc[item.section] || [];
                            acc[item.section].push(item);
                            break; // Exit loop after condition is met
                        } else {
                            if (item.section && item.section !== "A") {
                                acc[item.section] = acc[item.section] || [];
                                acc[item.section].push(item);
                                break; // Exit loop after condition is met
                            }
                        }
                    }
                }
            }
        }

        return acc; // Always return the accumulator at the end of the reduce iteration
    }, {});

    const handleItemClick = (item) => {
        setSelectedItem(item);
    };

    const renderSection = (section) => (
        <div style={{
            margin: '16px',
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
        }}>
            <Flex vertical>
                {groupedData[section].map(item => (
                    <Flex
                        justify='flex-start'
                        align='center'
                        gap={16}
                        key={item.name}
                        onClick={() => handleItemClick(item)}
                        style={{
                            padding: '8px 12px',
                            backgroundColor: selectedItem?.name === item.name ? colorPrimaryBg : 'transparent',
                            borderRadius: borderRadiusLG,
                            cursor: 'pointer',
                            color: selectedItem?.name === item.name ? colorText : 'inherit',
                        }}
                    >
                        <Flex justify='flex-start' align='center' style={{
                            backgroundColor: item.color,
                            padding: '8px 8px',
                            borderRadius: borderRadiusLG,
                             color:'#fff',
                        }}>
                            {item.icon}
                        </Flex>
                        <Flex justify='space-between' align='center' gap={16} style={{ width: '100%' }}>
                            <div>{item.name}</div>
                            <RightOutlined />
                        </Flex>
                    </Flex>
                ))}
            </Flex>

        </div>
    );

    const renderSelectedComponent = () => {

        switch (selectedItem?.name) {
            case 'Company Settings':
                return <CompanySetting />;
            case 'Meeting Integration Settings':
                return <MeetingIntegration />;
            case 'Profile Settings':
                return <UserProfile setUserProfileChanged={setUserProfileChanged} />;
            //   case 'Password Change':
            //     return <TimeSetting />;
            case 'Password Change':
                return <ChangePassword />;
            case 'eSignature':
                return <SignatureSettings />;
            case '2FA':
                return <TwoFactorAuth />;
            default:
                return <div>Select a setting to view details</div>;
        }
    };

    return (
        <>
            {/* <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            href: '',
                            title: <SettingOutlined />,
                        },
                        {
                            title: 'Settings',
                        },
                    ]}
                />
            </Flex> */}
            <div style={{ margin: '16px' }}>            
                {
                    Object.keys(filterValues).length !== 0 &&
                    <Flex align='center' gap={12}>
                        {Object.keys(filterValues).map(key => (
                            filterValues[key].length !== 0 &&
                            <Tag bordered={false} closable color="success" key={key}>
                                {filterValues[key]}
                            </Tag>
                        ))}
                    </Flex>
                }
            </div>
            <Row>
                {(screens.xs || screens.sm || screens.md || screens.lg || screens.xl || screens.xxl || !selectedItem) && (
                    <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                        <div style={{
                            position: 'sticky',
                            top: '16px',
                            maxHeight: 'calc(100vh - 32px)',
                            overflowY: 'auto',
                            margin: '16px',
                            padding: '8px 12px',
                            background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}>
                            <Flex justify='flex-start' align='center' gap={16} >
                                <Flex justify='flex-start' align='center' style={{ padding: '8px 8px', borderRadius: borderRadiusLG, }}>
                                    <Avatar size="large" src={imageUrl ? imageUrl : Empty_profile_pic} />
                                </Flex>
                                <Flex justify='space-between' align='center' gap={16} style={{ width: '100%' }}>
                                    <div style={{ fontSize: 16, fontWeight: 'bold', wordBreak:'break-all' }}>
                                        {name} <br />
                                        <span style={{ fontSize: 14, fontWeight: '300' }}>{roleName.toString()}</span>
                                    </div>                                    
                                </Flex>
                            </Flex>
                            {groupedData['A'] && renderSection('A')}
                            {groupedData['B'] && renderSection('B')}
                            {groupedData['C'] && renderSection('C')}
                        </div>
                    </Col>
                )}
                {(screens.md || screens.lg || screens.xl || screens.xxl) && selectedItem && (
                    <Col xxl={18} xl={18} lg={12} md={12} sm={24} xs={24}>
                        <div style={{ margin: '16px' }}>
                            {renderSelectedComponent()}
                        </div>
                    </Col>
                )}
            </Row>
        </>
    );
}
